import React from 'react';

/**
 * Page title block. Title is the only large element; lead, actions and the
 * optional toolbar (tabs, filters) sit under it in quieter type.
 */
const PageHeader = ({ title, eyebrow, lead, actions, children, className = '' }) => (
    <header className={['page-header', className].filter(Boolean).join(' ')}>
        <div className="page-header__row">
            <div className="page-header__text">
                {eyebrow ? <p className="page-header__eyebrow">{eyebrow}</p> : null}
                <h1 className="page-header__title">{title}</h1>
                {lead ? <p className="page-header__lead">{lead}</p> : null}
            </div>
            {actions ? <div className="page-header__actions">{actions}</div> : null}
        </div>
        {children}
    </header>
);

export default PageHeader;
